export const convertWrapUpRoute = (wrapUpRoutes) => {
  let defaultValue = [
    {
      name: 'level_1',
      level: 1,
      title: '',
      subWrapUp: []
    }
  ]
  if (wrapUpRoutes) {
    const result = wrapUpRoutes
      .map((wrapUpRoute) => {
        const level1 = Object.hasOwnProperty.call(wrapUpRoute, 'level_1')
          ? wrapUpRoute.level_1
          : null
        return {
          name: 'level_1',
          level: 1,
          title: level1 ? level1.title : '',
          subWrapUp: level1 ? handleGetSubWrapUp(level1) || [] : []
        }
      })
      .filter(Boolean)
    return result.length > 0 ? result : defaultValue
  }

  return defaultValue
}

export const handleGetSubWrapUp = (wrapUpRoute) => {
  // get recursive function sub wrap up by key level_2, level_3, level_4 , level_n
  const subWrapUp = []
  const keys = Object.keys(wrapUpRoute)
  keys.forEach((key) => {
    if (key.includes('level_')) {
      wrapUpRoute[key].forEach((swu) => {
        subWrapUp.push({
          name: key,
          level: +key.split('_')[1],
          title: swu.title,
          subWrapUp: handleGetSubWrapUp(swu)
        })
      })
    }
  })
  return subWrapUp
}



// WEBPACK FOOTER //
// ./src/utils/wrapUp.js